<template>
  <div v-if="currentCharts" class="columns is-multiline">
    <div
      v-for="(chart, i) in DASHBOARD_CHART_DEFINITION"
      :key="i"
      class="column"
      :class="[`is-${chart.gridWidth} `, chart.heightClass ? chart.heightClass : 'base-column']"
    >
      <ChartWrapper
        v-if="currentCharts[chart.name]"
        :chartAttr="chart"
        :chartData="getChartData(chart.name)"
        :toolTipIndex="toolTipIndex"
        @tooltipIndexChanged="tooltipIndexChanged"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DASHBOARD_CHART_DEFINITION } from "@/misc/desktopCharts";
import ChartWrapper from "./Chart/Index";
export default {
  components: {
    ChartWrapper,
  },
  data() {
    return {
      DASHBOARD_CHART_DEFINITION: DASHBOARD_CHART_DEFINITION,
      toolTipIndex: null,
    };
  },
  computed: {
    ...mapGetters({
      currentCharts: "dashboard/currentCharts",
    }),
  },
  methods: {
    getChartData(name) {
      return this.currentCharts[name];
    },
    tooltipIndexChanged(index) {
      this.toolTipIndex = index;
    },
  },
};
</script>

<style scoped>
.base-column {
  height: 256px;
}

.high-column {
  height: 316px;
}
</style>
